import { s__ } from '~/locale';

export const TITLE_LABEL = s__('MlExperimentTracking|Model experiments');

export const CREATE_NEW_LABEL = s__('MlExperimentTracking|Create a new experiment');

export const EMPTY_STATE_TITLE_LABEL = s__(
  'MlExperimentTracking|Get started with model experiments!',
);

export const EMPTY_STATE_DESCRIPTION_LABEL = s__(
  'MlExperimentTracking|Experiments keep track of comparable model candidates, and determine which parameters provides the best performance. Create experiments using the MLflow client',
);
